
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"20","height":"20"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 1618"}},[_c('path',{attrs:{"data-name":"Rectangle 2337","fill":"none","d":"M0 0h20v20H0z"}}),_c('g',{attrs:{"data-name":"Group 1619","transform":"translate(-713.055 -428.143)"}},[_c('rect',{attrs:{"data-name":"Rectangle 2338","width":"16","height":"20","rx":"1","transform":"translate(715.055 428.143)","fill":"#adadad"}}),_c('path',{attrs:{"data-name":"Rectangle 2339","d":"M722.055 432.143h7v2h-7z"}}),_c('circle',{attrs:{"data-name":"Ellipse 201","cx":"1.5","cy":"1.5","r":"1.5","transform":"translate(717.055 431.643)","fill":"#fff"}}),_c('path',{attrs:{"data-name":"Rectangle 2340","d":"M722.055 437.143h7v2h-7z"}}),_c('circle',{attrs:{"data-name":"Ellipse 202","cx":"1.5","cy":"1.5","r":"1.5","transform":"translate(717.055 436.643)","fill":"#fff"}}),_c('path',{attrs:{"data-name":"Rectangle 2341","d":"M722.055 442.143h7v2h-7z"}}),_c('circle',{attrs:{"data-name":"Ellipse 203","cx":"1.5","cy":"1.5","r":"1.5","transform":"translate(717.055 441.643)","fill":"#fff"}})])])])
          )
        }
      }
    